import React, { useState , useRef, useCallback} from "react";
import { connect } from "react-redux";
import { LoadPanel } from 'devextreme-react/load-panel';
import RadioGroup from 'devextreme-react/radio-group';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import { alert, confirm } from 'devextreme/ui/dialog';
import axios from "axios";
import { custom } from 'devextreme/ui/dialog';


function BillToCharges(props) {
    let accessToken = props.oidc.user.access_token;
    const position = { of: '#accordion-containe2' };
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);

    const[itemBillTo, setItemBillTo] = useState("");
    const itemBillTos = [
        { id: "Customer", text: "Customer" },
        { id: "Consignee", text: "Consignee" }
    ];
    const[transactionBillTo, setTransactionBillTo] = useState("");
    const transactionBillTos = [
        { id: "Customer", text: "Customer" },
        { id: "Consignee", text: "Consignee" }
    ];

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            await UpdateChargesBillTo();

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const handleCancel = () => {
        props.ClosePopup();
    };

    const UpdateChargesBillTo = async () => {
        try {
            const url = "wm/TransactionHeaderOperations/UpdateChargesBillTo";
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, 
                { 
                    TransactionHeaderRowId : props.TransactionHeaderRowId, 
                    ItemBillTo: itemBillTo, TransactionBillTo: transactionBillTo 
                }, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                });

            if (response.data.success) {
                setIsFormSubmitted(false);
                 props.ClosePopup();
                 props.Success();
            } else {
                alert(response.data.message,"Error");
                setIsFormSubmitted(false);
            }
        } catch (error) {
            alert("An error occurred", error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    return (
        <div style={{marginLeft: '-11px'}}>
            <div id="accordion">
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    onHiding={hideLoadPanel}
                    visible={loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                />
                <form onSubmit={(e) => handleFormSubmit(e)}>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <fieldset className='col-md-6 col-fieldset'>
                            <legend className="list-title">Item Charges</legend>
                            <RadioGroup
                                items={itemBillTos}
                                defaultValue=""
                                value={itemBillTo}
                                valueExpr="id"
                                displayExpr="text"
                                layout="vertical"
                                onValueChanged={e => { 
                                    setItemBillTo(e.value); 
                                }}
                            />
                        </fieldset>
                        <fieldset className='col-md-6 col-fieldset' style={{marginLeft: '5px'}}>
                            <legend className="list-title">Transaction Charges</legend>
                            <RadioGroup
                                items={transactionBillTos}
                                defaultValue=""
                                value={transactionBillTo}
                                valueExpr="id"
                                displayExpr="text"
                                layout="vertical"
                                onValueChanged={e => { 
                                    setTransactionBillTo(e.value); 
                                }}
                            />
                        </fieldset>
                    </div>
                    <div style={{ marginTop: '10px' }}></div>
                    <Toolbar className="header">
                        <Item location="center">
                            <Button
                                text="Apply"
                                useSubmitBehavior={true}
                                disabled={isFormSubmitted}
                                type="default"
                                className="accordianButton"
                            />
                        </Item>
                        <Item location="center">
                            <Button className="accordianButton" onClick={handleCancel} text="Cancel" />
                        </Item>
                    </Toolbar>
                </form>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(BillToCharges);
